<div *ngIf="(quotation$ | async) as quote" class="quote-summary card" data-testId="quote-summary">
  <section class="quote-summary__topic">
    <h3 class="font-weight-bold">{{ 'header' | translate }}</h3>
    <i id="editButton" *ngIf="isEditable" (click)="onEdit()" aria-hidden="true" class="fa fa-edit" data-testId="editBtn"></i>
  </section>
  <section class="quote-summary__content">
    <div class="content-item">
      <section>
        <h5 class="content-item__topic">{{ 'insurancePlan' | translate }}</h5>
        <div class="content-item__detail ">
          <p class="highlight font-weight-bold" data-testId="insurancePlan">{{ quote.insurancePlan?.topLevelDesc }}</p>
          <p>
            {{ 'for' | translate }}
            <span class="highlight" data-testId="numPeople">{{ quote.numPeople?.code }}</span>
            {{ 'persons' | translate }}
          </p>
        </div>
      </section>
    </div>
    <div class="content-item">
      <section>
        <h5 class="content-item__topic">{{ 'destination' | translate }}</h5>
        <div class="content-item__detail">
          <p class="highlight" *ngIf="isSigleTrip(quote.travelType)" data-testId="travelType">
            {{ 'singleTrip' | translate }}
          </p>
          <p class="highlight" *ngIf="isAnnualTrip(quote.travelType)" data-testId="travelType">
            {{ 'annualTrip' | translate }}
          </p>
          <section class="destination-wrapper">
            <span *ngIf="quote.from" class="highlight" data-testId="fromCountry">{{ quote.from | masterDataTranslate | async }}</span>

            <i class="fa fa-arrow-right" aria-hidden="true"></i>

            <section class="destination-wrapper__to">
              <span *ngFor="let to of quote.to; let i = index">
                <span class="highlight" data-testId="toCountry"
                  >{{ to | masterDataTranslate | async }}<span *ngIf="quote.to?.length !== 1 && quote.to?.length !== i + 1">, </span></span
                >
              </span>
            </section>
          </section>
        </div>
      </section>
    </div>
    <div class="content-item">
      <section>
        <h5 class="content-item__topic">{{ 'protectionPeriod' | translate }}</h5>
        <div class="content-item__detail">
          <p class="date" data-testId="date">
            {{ quote.fromDate?.day }}/{{ quote.fromDate?.month }}/{{ quote.fromDate?.year }}
            -
            {{ quote.toDate?.day }}/{{ quote.toDate?.month }}/{{ quote.toDate?.year }}
          </p>
          <p class="highlight" data-testId="duration">{{ quote.duration }} {{ 'days' | translate }}</p>
        </div>
      </section>
    </div>
  </section>
  <hr />
  <section class="quote-summary__price">
    <div class="price-detail">
      <p class="price-detail__total">
        <span class="totalPremium">{{ 'totalPremium' | translate }}</span>
      </p>
      <p class="price-detail__total" data-testId="productPrice">
        <span class="price">{{ productPrice$ | async }}</span> <span class="price-unit">{{ 'baht' | translate }}</span>
      </p>
    </div>
  </section>
  <p class="price-at-date" data-testId="dateWhenGetPrice">
    <span>{{ 'price' | translate }}</span
    ><span>{{ 'on' | translate }}</span> {{ quote.dateWhenGetPrice }}
  </p>
</div>
